import type { CSSProperties, ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type Status =
  | 'submitted'
  | 'updated'
  | 'pending'
  | 'queued'
  | 'sending'
  | 'accepted'
  | 'confirmed'
  | 'rejected'
  | 'failed'
  | 'offline';

const MAP: Record<Status, { icon: IconName; color: string }> = {
  pending: { icon: 'time-outline', color: 'var(--color-pending)' },
  queued: { icon: 'cloud-upload-outline', color: 'var(--color-pending)' },
  sending: { icon: 'sync-outline', color: 'var(--color-text-secondary)' },
  submitted: { icon: 'checkmark-circle', color: 'var(--color-success)' },
  updated: { icon: 'create-outline', color: 'var(--color-success)' },
  accepted: { icon: 'checkmark-circle', color: 'var(--color-success)' },
  confirmed: { icon: 'checkmark-circle', color: 'var(--color-success)' },
  rejected: { icon: 'close-circle', color: 'var(--color-danger)' },
  failed: { icon: 'alert-circle', color: 'var(--color-danger)' },
  offline: { icon: 'cloud-offline-outline', color: 'var(--color-offline)' },
};

export interface StatusLabelProps {
  status: Status;
  /** The word. Always supplied from messages; colour never carries meaning alone. */
  children: ReactNode;
  style?: CSSProperties;
}

export function StatusLabel({ status, children, style }: StatusLabelProps) {
  const s = MAP[status];
  return (
    <span className="fw-status" style={{ color: s.color, ...style }}>
      <Icon name={s.icon} size={18} />
      <span className="fw-status__text">{children}</span>
    </span>
  );
}
